module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "proxy-steps"
    }
  }, [_c('v-stepper', {
    attrs: {
      "alt-labels": "",
      "non-linear": ""
    },
    model: {
      value: (_vm.proxyStep),
      callback: function($$v) {
        _vm.proxyStep = $$v
      },
      expression: "proxyStep"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "1"
    }
  }, [_vm._v("Item Information")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "2"
    }
  }, [_vm._v("Customer Information")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "3"
    }
  }, [_vm._v("Shipping Method")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Product",
      "items": _vm.products,
      "item-text": "name",
      "item-value": "name",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.project.product.name),
      callback: function($$v) {
        _vm.$set(_vm.project.product, "name", $$v)
      },
      expression: "project.product.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Item Name",
      "rules": _vm.requiredRules,
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.project.name),
      callback: function($$v) {
        _vm.$set(_vm.project, "name", $$v)
      },
      expression: "project.name"
    }
  }), _vm._v(" "), _c('item-summary', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('contact-input', {
    attrs: {
      "contact-title": "Shipping Information",
      "show-res-check-box": true,
      "contact": _vm.shippingAddress
    },
    on: {
      "change": function($event) {
        return _vm.changeContact($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('shipping-methods', {
    attrs: {
      "shipping-method": _vm.shippingMethod,
      "address": _vm.shippingAddress,
      "item": _vm.project
    },
    on: {
      "change": function($event) {
        return _vm.$emit('save-shipping-method', $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-sm-right",
    attrs: {
      "s12": ""
    }
  }, [(_vm.proxyStep > 1) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.proxyStep -= 1
      }
    }
  }, [_vm._v("Back")]) : _vm._e(), _vm._v(" "), (_vm.proxyStep < 3) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAndNext($event)
      }
    }
  }, [_vm._v("Continue")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e091302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/proxy/create/steps.vue
// module id = 725
// module chunks = 1